import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import DialogContentWrapper from "../../../common/components/functional/dialogs/DialogContentWrapper";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { normalizeUserMessageChannels } from "../../userMessages/userMessagesHelpers";
import { UserMessageByIdResponse } from "../../userMessages/userMessagesTypes";
import UserMessageDialogContent, {
  UserMessageDialogHeader,
} from "./UserMessageDialogContent";

interface Props {
  open: boolean;
  onClose: () => void;
  message: UserMessageByIdResponse | null;
  isLoading: boolean;
  senderName: string;
  hasSenderDetails: boolean;
  customerName: string;
  isInAppNotice: boolean;
}

const UserMessageDialog = ({
  open,
  onClose,
  message,
  isLoading,
  senderName,
  hasSenderDetails,
  customerName,
  isInAppNotice,
}: Props) => {
  const { t } = useTranslation(["userMessages", "common"]);
  const hasContent = !isLoading && message != null;

  return (
    <DialogComponent open={open} onClose={onClose} variant="form">
      <DialogContentWrapper
        headerSx={{ textTransform: "none", fontWeight: 400 }}
        title={
          hasContent ? (
            <UserMessageDialogHeader
              senderName={senderName}
              hasSenderDetails={hasSenderDetails}
              fromNoReplyAddress={message.fromNoReplyAddress}
              includesEmail={normalizeUserMessageChannels(message.channels).includes(
                "Email",
              )}
              isInAppNotice={isInAppNotice}
            />
          ) : (
            ""
          )
        }
        onCancel={onClose}
        customCancelButtonLabel={t("common:close")}
      >
        <Grid item xs={12}>
          {hasContent ? (
            <UserMessageDialogContent
              message={message}
              customerName={customerName}
            />
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight={280}
            >
              <LoadingSpinner />
            </Box>
          )}
        </Grid>
      </DialogContentWrapper>
    </DialogComponent>
  );
};

export default UserMessageDialog;
